<template>
    <section class="user-banner">
        <div class="user-banner__bg -wrap">
            <span class="user-banner__headline -wrap" v-html="$t('UserBanner.welcome_back')"></span>
        </div>

        <ul class="user-banner__tabs -wrap-no-margins" v-if="isDesktopBannerTabs">
            <li v-for="(menuItem, index) in filteredUserMenu"
                :key="index"
                :class="['user-banner__tab', {'-active': activeTab === menuItem.href.name}]"
            >
                <template v-if="menuItem.attributes.id === 'logout'">
                    <div @click="logout" class="user-banner__link" >
                        {{ menuItem.title }}
                    </div>
                </template>
                <template v-else>
                    <router-link :to="{ name: menuItem.href.name }" class="user-banner__link">
                        {{ menuItem.title }}
                    </router-link>
                </template>
            </li>
        </ul>

        <TotemSelect
            :options="mobileUserMenu"
            :value="selectedUserPageOption"
            @input="goToUserPage"
            :clearable="false"
            v-if="!isDesktopBannerTabs"
            class="user-banner__select"
        >
        </TotemSelect>

    </section>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data () {
            return {
                activeTab: this.$route.name
            }
        },
        computed: {
            ...mapGetters({
                userMenu: 'Menu/getUserMenu',
                user: 'User/getCurrentUser'
            }),
            isDesktopBannerTabs () {
                return this.$mq.includes('desktop_xxxl') || this.$mq.includes('desktop_xxl')
            },
            mobileUserMenu () {
                return this.userMenu
                    .filter(el => el.attributes.id !== 'knowledge-center' && el.attributes.id !== 'logout')
                    .map(el => ({
                        label: el.title,
                        value: el.href.name
                    }))
            },
            selectedUserPageOption () {
                return this.mobileUserMenu.find(el => el.value === this.$route.name)
            },
            filteredUserMenu () {
                return this.userMenu.filter((menuItem) => menuItem.attributes.id !== 'knowledge-center' && menuItem.attributes.id !== 'logout');
            }
        },
        methods: {
            goToUserPage (option) {
                this.$router.push({ name: option.value })
            },
            logout () {
                this.$store.dispatch('logout')
                this.$router.push({ name: 'home' })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .user-banner {
        background-color: $gallery;
        display: flex;
        align-items: center;
        padding: 0 20px 0 0;

        [class*="desktop_xxxl"] &,
        [class*="desktop_xxl"] &,
        [class*="mobile_sm"] & {
            flex-direction: column;
            padding: 0;
        }

        &__select {
            [class*="mobile_sm"] & {
                margin: 0 0 20px 0;
            }
        }

        &__bg {
            background-color: $gallery;
            height: 120px;
            display: flex;
            align-items: center;
        }
        &__headline {
            font-family: Quicksand-Regular, sans-serif;
            font-size: 2.8rem;
            font-weight: 400;
            color: $black;
            padding: 0;
        }
        &__tabs {
            display: flex;
            min-height: 60px;
            height: 100%;
            padding: 0;
            list-style-type: none;
            flex: 1;
            margin: 0;
            width: 100%;
            flex-direction: row;
        }
        &__tab {
            background-color: $heavy_metal;
            padding: 0 20px;
            border-right: 1px solid $white;
            min-height: 40px;
            flex: 1;
            justify-content: center;
            align-items: center;
            display: flex;

            &:last-of-type {
                border-right: none;
            }

            &.-active {
                background-color: $orange;

                .user-banner__link {
                    font-family: Nunito-ExtraBold, sans-serif;
                    color: $white;
                }
            }
        }
        &__link {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            color: $white;
            cursor: pointer;

            & > span {
                margin: 0 10px 0 0;
            }
        }
    }
</style>
